module.exports = __webpack_public_path__ + "img/trial2-2.7bd3007c.png";